// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-main[data-v-3c9487fa]{padding-bottom:0!important}.v-navigation-drawer[data-v-3c9487fa]{max-height:100%!important}.posAbs[data-v-3c9487fa]{position:absolute}.desktopLogo[data-v-3c9487fa]{margin-top:0!important;width:256px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
